var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box",style:({
    height: _vm.itemData.height + 'px',
    background: `url(${_vm.itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% 100%`,
    padding: `${_vm.itemData.padding.top}px ${_vm.itemData.padding.right}px ${_vm.itemData.padding.bottom}px ${_vm.itemData.padding.left}px`,
  })},[_c('div',{attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }